/* eslint-disable */
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { connect } from "react-redux";
import Select from "react-select";

import { serviceProviderActions as actions } from "../../../actions";
import {
  serviceProvidersSortedSelector,
  spFullNameSelector
} from "../../../reducers/serviceProvider";

interface ServiceProviderModalProps {
  title: string;
  data: any;
  cancel: () => void;
  saveFn: (...any) => void;
  serviceProviders: any;
  loadServiceProviders: (id: string) => void;
  resourceCentreId: string;
}

const ServiceProviderModal: React.FunctionComponent<ServiceProviderModalProps> = ({
  title,
  data,
  saveFn,
  cancel,
  serviceProviders,
  loadServiceProviders,
  resourceCentreId
}) => {
  React.useEffect(() => {
    !Boolean(serviceProviders.length) && loadServiceProviders(resourceCentreId);
  }, []);
  const [serviceProviderId, setServiceProviderId] = React.useState(null);
  const optionsForSelect = (sps) => {
    return sps.map((sp) => {
      return { label: spFullNameSelector(sp), value: sp.id };
    });
  };
  return (
    <Dialog open={true} slotProps={{ paper: { sx: { overflowY: "visible" } } }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent
        sx={{
          overflowY: "visible"
        }}
      >
        <Select
          placeholder="Service provider..."
          value={optionsForSelect(serviceProviders).find(({ value }) => value == serviceProviderId)}
          options={optionsForSelect(serviceProviders)}
          onChange={({ value }) => setServiceProviderId(value)}
        ></Select>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="secondary" onClick={cancel}>
          Cancel
        </Button>
        <Button
          disabled={!Boolean(serviceProviderId)}
          variant="contained"
          color="primary"
          onClick={() => {
            saveFn({ ...data, serviceProviderId });
            cancel();
          }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function mapStateToProps(state) {
  return {
    serviceProviders: serviceProvidersSortedSelector(state),
    resourceCentreId: state.userContext.resourceCentreId
  };
}

function matchDispatchToProps(dispatch) {
  return {
    loadServiceProviders: (id) =>
      dispatch(actions.getResourceCentreServiceProviders({ resourceCentreId: id }))
  };
}

export default connect(mapStateToProps, matchDispatchToProps)(ServiceProviderModal);
